import React from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { WhoFor } from "@/components/site/WhoFor";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Benefits } from "@/components/site/Benefits";
import { MealGallery } from "@/components/site/MealGallery";
import { ChefTestimonial } from "@/components/site/ChefTestimonial";
import { Testimonials } from "@/components/site/Testimonials";
import { QuizForm } from "@/components/site/QuizForm";
import { FAQ } from "@/components/site/FAQ";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";
import { SectionCta } from "@/components/site/SectionCta";
import { MarfitCrossNav } from "@/components/site/MarfitCrossNav";

export default function Landing() {
    return (
        <div className="bg-background text-foreground min-h-screen">
            <Header />
            <main>
                <Hero />
                <WhoFor />

                {/* CTA #1 — soft beige card after the "who is it for" reveal */}
                <SectionCta
                    variant="soft"
                    eyebrowKey="cta.after_whofor.eyebrow"
                    titleKey="cta.after_whofor.title"
                    subtitleKey="cta.after_whofor.subtitle"
                    ctaKey="cta.after_whofor.button"
                    testId="cta-after-whofor"
                />

                <HowItWorks />
                <Benefits />

                {/* CTA #2 — short inline strip after benefits */}
                <SectionCta
                    variant="inline"
                    titleKey="cta.after_benefits.title"
                    ctaKey="cta.after_benefits.button"
                    testId="cta-after-benefits"
                />

                <MealGallery />
                <ChefTestimonial />

                {/* CTA #3 — high-emphasis dark band right after meeting the chef */}
                <SectionCta
                    variant="dark"
                    eyebrowKey="cta.after_chef.eyebrow"
                    titleKey="cta.after_chef.title"
                    subtitleKey="cta.after_chef.subtitle"
                    ctaKey="cta.after_chef.button"
                    testId="cta-after-chef"
                />

                <Testimonials />
                <QuizForm />

                {/* Cross-nav to MarFit Meals — after quiz, before FAQ */}
                <MarfitCrossNav />

                <FAQ />

                {/* CTA #4 — final nudge after FAQ before footer */}
                <SectionCta
                    variant="soft"
                    eyebrowKey="cta.after_faq.eyebrow"
                    titleKey="cta.after_faq.title"
                    subtitleKey="cta.after_faq.subtitle"
                    ctaKey="cta.after_faq.button"
                    testId="cta-after-faq"
                />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}
